import { Component } from "@angular/core";

@Component({
    standalone: false,
    selector: "footer-bar",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.css"]
})
export class FooterBar {
    year = new Date().getFullYear();
}
